export default __webpack_public_path__ + "static/avatar_drivescore-9d9eae4f8a616cd57033d4b52a3fe9ba.png";